import { BaseYcState, RegisterYCState } from '@yourcause/common/state';


@RegisterYCState()
export class SubmittedSupportRequestsState extends BaseYcState {
  readonly supportRequestStatuses: string[];
}
